import { stats } from "@/mocks/homeData";

const heroChips = [
  { label: "表情包大全", href: "#emoji" },
  { label: "沙雕图", href: "#silly" },
  { label: "热梗梗图", href: "#meme" },
  { label: "吃瓜头像", href: "#avatar" },
  { label: "高清壁纸", href: "#wallpaper" },
  { label: "周边衍生", href: "#peripheral" },
];

export default function Hero() {
  return (
    <section id="hero" className="relative overflow-hidden pt-[68px]">
      {/* 背景大图 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=wide%20stylized%20illustration%20of%20a%20dreamy%20watermelon%20field%20with%20big%20ripe%20melons%20and%20green%20leaves%20under%20a%20warm%20sunny%20sky%2C%20cute%20flat%20vector%20art%20with%20soft%20shapes%2C%20a%20few%20chubby%20happy%20watermelon%20characters%20peeking%20out%2C%20floating%20popcorn%20and%20bubbles%2C%20warm%20coral%20orange%20and%20fresh%20green%20palette%2C%20playful%20vibrant%20cheerful%20mood%2C%20clean%20high%20quality%20illustration&width=1600&height=1000&seq=hero-field-2026&orientation=landscape"
          alt="52吃瓜表情包瓜田插画背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/55 to-background-50" />
        <div className="watermelon-stripe absolute bottom-0 left-0 right-0 h-2 opacity-80" />
      </div>

      <div className="relative mx-auto flex max-w-[1200px] w-full flex-col items-center px-4 pt-14 pb-20 text-center md:px-6 md:pt-20 md:pb-24">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/85 px-4 py-1.5 text-sm font-semibold text-accent-700 shadow-sm backdrop-blur">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500" />
          </span>
          瓜田今日 · 表情包持续更新中
        </span>

        <h1 className="mt-6 max-w-4xl font-heading text-4xl leading-tight text-foreground-950 md:text-6xl">
          52吃瓜 · 表情包图鉴站
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
          🍿 表情包、沙雕图、梗图这里都有。吃瓜头像、壁纸、周边衍生图持续更新，
          存图自用或斗图都合适，让你在瓜田里聊得更有梗。
        </p>

        {/* 快捷标签 */}
        <div className="mt-7 flex flex-wrap items-center justify-center gap-2.5">
          {heroChips.map((chip) => (
            <a
              key={chip.label}
              href={chip.href}
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/85 px-4 py-2 text-sm font-medium text-foreground-800 shadow-sm backdrop-blur hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer"
            >
              <i className="ri-hashtag text-accent-600" />
              {chip.label}
            </a>
          ))}
        </div>

        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#emoji"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-base font-semibold text-background-50 hover:bg-primary-600 transition-colors sm:w-auto cursor-pointer"
          >
            开始逛表情包
            <i className="ri-arrow-right-down-line" />
          </a>
          <a
            href="#hot"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-7 py-3 text-base font-semibold text-background-50 hover:bg-foreground-800 transition-colors sm:w-auto cursor-pointer"
          >
            看今日热搜
            <i className="ri-fire-line" />
          </a>
        </div>

        {/* 数据统计 */}
        <dl className="mt-12 grid w-full grid-cols-2 gap-4 sm:grid-cols-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-2xl bg-background-50/80 px-4 py-4 text-center shadow-sm backdrop-blur"
            >
              <dt className="order-2 mt-1 text-xs text-foreground-600">{s.label}</dt>
              <dd className="font-heading text-2xl text-primary-600 md:text-3xl">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}